export default __webpack_public_path__ + "static/media/bindo.0003cd61.webp";